import { Box, Modal, IconButton, Typography, Button } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

interface UnstableConnectionModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const UnstableConnectionModal = ({ isOpen, onClose }: UnstableConnectionModalProps) => {
  return (
    <>
      <Modal
        open={isOpen}
        onClose={onClose}
        aria-label="modal-unstable-connection"
        aria-description="A modal informing you that your connection is unstable. You may neeed to connect your device via hard wire."
      >
        <Box sx={{
          position: "relative", backgroundColor: "white", textAlign: "center",
          padding: "28px", width: "470px", minHeight: "130px",
          top: "50%", left: "50%", transform: "translate(-50%, -50%)",
          borderRadius: "12px",
        }}>
          <IconButton onClick={onClose} sx={{ position: "absolute", width: "24px", height: "24px", right: "24px", top: "19px"}}>
            <CloseIcon />
          </IconButton>

          <Typography sx={{ color: "#455459", fontSize: "20px", marginBottom: "15px" }} variant="body1" >{"You may need to connect via hardwire."}</Typography>
          <Typography sx={{ color: "#455459", fontSize: "12px" }} variant="body2" >{"If you are unable to, please contact an administrator."}</Typography>
        </Box>
      </Modal>
    </>
  )
}

export default UnstableConnectionModal;